export const tryEncodeUriComponent = (url: string): string => {
    try {
        return encodeURIComponent(url)
    } catch (error) {
        // Ignore
    }
    return url;
}

export const tryDecodeUri = (url: string): string => {
    try {
        return decodeURI(url)
    } catch (error) {
        // Ignore
    }
    return url;
}

export const tryDecodeUriComponent = (url: string): string => {
    try {
        return decodeURIComponent(url)
    } catch (error) {
        // Ignore
    }
    return url;
}

/**
 * Escapes a value for interpolation into an OData string literal ('...'):
 * single quotes are doubled per the OData spec.
 */
export const escapeODataString = (value: string): string => value?.replace(/'/g, "''");

export const encodePath = (value: string): string => {

    if (typeof value === "undefined" || value === null || value.length < 1) {
        return "";
    }

    // replace all instance of ' with ''
    if (/!(@.*?)::(.*?)/ig.test(value)) {

        return value.replace(/!(@.*?)::(.*)$/ig, (match, labelName, v) => {
            // we do not need to encodeURIComponent v as it will be encoded automatically when it is added as a query string param
            // we do need to double any ' chars
            return `!${labelName}::${v.replace(/'/ig, "''")}`;
        });

    } else {

        // because this is a literal path value we encodeURIComponent after doubling any ' chars
        return encodeURIComponent(value.replace(/'/ig, "''"));
    }
}